import { createStore } from 'vuex'

export default createStore({
    state: {
        // 关于我们
        aboutUsInfo: [], // 内容
        aboutUsItem: 0,  // 左侧菜单所选Item，数字表示选择了第几项，文字表示选择了具体哪个Item
        // 课程中心
        courseCenterTotal: 0,        // 课程总数
        courseCenterSideFilters: [], // 左侧菜单筛选项
        courseCenterTopFilters: [],  // 顶部菜单筛选项
        courseCenterList: [],        // 课程列表
        // 课程详情
        courseDetail: {}, // 课程详情
        // 用户中心
        userCenterInfo: {}, // 个人信息
        // 通用
        searchKeyword: "", // 搜索框关键字
        // 课程支付
        paymentOrderInfo: {}, // 支付过程中的订单信息
    },
    mutations: {
        // 关于我们
        updateAboutUsInfo(state, newValue) {
            state.aboutUsInfo = newValue;
        },
        aboutUsItemSelected(state, item) {
            state.aboutUsItem = item;
        },
        // 课程中心
        updateCourseCenterTotal(state, newValue) {
            state.courseCenterTotal = newValue;
        },
        updateCourseSideFilters(state, newValue) {
            state.courseCenterSideFilters = newValue;
        },
        updateCourseTopFilters(state, newValue) {
            state.courseCenterTopFilters = newValue;
        },
        updateCourseList(state, newList) {
            state.courseCenterList = newList;
        },
        // 课程详情
        updateCourseDetail(state, newValue) {
            state.courseDetail = newValue;
        },
        // 更新用户中心个人信息
        updateUserCenterInfo(state, newValue) {
            state.userCenterInfo = newValue;
        },
        // 更新搜索框关键字
        updateSearchKeyword(state, newValue) {
            state.searchKeyword = newValue;
        },
        // 更新支付过程中的订单信息
        updatePaymentOrderInfo(state, newValue) {
            state.paymentOrderInfo = newValue;
        }
    },
    actions: {
    },
    modules: {
    },
    getters: {
        courseVideoList(state) {
            return state.courseDetail.courseSchedule;
        },
        userInfo(state) {
            return state.userCenterInfo;
        }
    }
})


